import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AuthContext from "../../components/auth-context";
import useAppNavigate from "../../components/router/use-app-navigate";
import Form from "../../components/inputs/form";
import Submit from "../../components/inputs/submit";
import Textbox from "../../components/inputs/textbox";
import RegisterBankReceiptApi from "../../api/registerBankReceipt";
import RequesterBankReceiptForm from "../../types/bank-receipt";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { unLocalizeNumbers } from "../../functions";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { DateObject } from "react-multi-date-picker";

function RegisterBankReceipt() {
  const context = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RequesterBankReceiptForm>();
  const [bankReceipts, setBankReceipts] = useState([]);
  const [ReceiptDate, setRegisterDate] = useState<DateObject | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const [selectedBankReceipts, setSelectedBankReceipts] = useState<string>();
  const navigate = useAppNavigate();

  const onSubmit: (data: any) => Promise<string> = ({
    Amount,
    Serial,
    BankAccountId,
    BranchCode,
    UserDescription,
  }) => {
    return new RegisterBankReceiptApi(context)
      .post({
        Amount,
        ReceiptDate: +unLocalizeNumbers(ReceiptDate!.format("YYYYMMDD")),
        Serial,
        BankAccountId,
        BranchCode,
        UserDescription,
      })
      .then((response) => {
        if (response.errorMessage != null) {
          setErrorMessage(response.errorMessage);
          return response.errorMessage;
        } else {
          navigate("/");
        }
      });
  };

  useEffect(() => {
    const registerBankReceiptApi = new RegisterBankReceiptApi(context);
    registerBankReceiptApi.get().then((data) => {
      setBankReceipts(data);
    });
  }, [context]);

  return (
    <>
      <ul className="text-red-500 text-right">
        <li>{errorMessage}</li>
      </ul>
      <Form submit={onSubmit} handleSubmit={handleSubmit}>
        <div className="form-group flex">
          <label htmlFor="" className="col-sm-3 m-2">
            تاریخ واریز
          </label>

          <div className="flex flex-row gap-2 mt-2 w-full max-w-[400px] box-border">
            <DatePicker
              inputClass="w-full max-w-[400px] box-border"
              className="w-full max-w-[400px] box-border p-5"
              calendar={persian}
              locale={persian_fa}
              value={ReceiptDate}
              render={<InputIcon tabIndex={9} />}
              calendarPosition="bottom-right"
              onChange={(d) => {
                if (Array.isArray(d)) d = d[0];
                setRegisterDate(d);
              }}
            />
            <input type={"hidden"} value={ReceiptDate?.format()} />
            {errors.ReceiptDate && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>
        <div className="form-group flex">
          <label htmlFor="" className="col-sm-3 pt-5 m-2">
            به حساب
          </label>
          <div className="mt-2 p-2 w-full max-w-[400px] box-border">
            <select
              {...register("BankAccountId", { required: true })}
              value={selectedBankReceipts}
              className="mt-2 p-2 w-full max-w-[400px] box-border"
              tabIndex={13}
              onChange={(e) => setSelectedBankReceipts(e.target.value)}
            >
              {bankReceipts.map(({ title, id }) => (
                <option value={id} key={id}>
                  {title}
                </option>
              ))}
            </select>
            {errors.BankAccountId && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        <Textbox
          {...register("Amount", {
            required: "مقدار مبلغ الزامی است",
            min: 1,
            max: 10_000_000_000,
          })}
          label="مبلغ"
          helpNote="واحد مبلغ فیش ریال می باشد"
          className={"w-full max-w-[400px] box-border"}
        />
        {errors.Amount && (
          <span className="text-red-500">{errors.Amount?.message}</span>
        )}

        <Textbox
          {...register("Serial", { required: "سریال فیش الزامی است" })}
          label="سریال فیش"
          className={"w-full max-w-[400px] box-border"}
        />
        {errors.Serial && (
          <span className="text-red-500">{errors.Serial?.message}</span>
        )}

        <Textbox
          {...register("BranchCode", { min: 0, max: 100000, required: true })}
          label="کدشعبه واریز"
          helpNote="کد شعبه ای که فیش در آن ثبت شده است."
          className={"w-full max-w-[400px] box-border"}
        />
        {errors.BranchCode && (
          <span className="text-red-500">کد شعبه باید بین 0 و 100000 باشد</span>
        )}

        <Textbox
          {...register("UserDescription", { min: 5, max: 100, required: true })}
          className={"w-full max-w-[400px] box-border"}
          label="توضیحات"
        />
        {errors.UserDescription && (
          <span className="text-red-500">کد شعبه باید بین 5 و 100 باشد</span>
        )}
        <Submit />
      </Form>
    </>
  );
}
export default RegisterBankReceipt;
